import { createFileRoute } from '@tanstack/react-router'
import { ResidentConversationPage } from '../components/conversations/ResidentConversationPage'

// The resident's conversation page (spec 2026-09-02-05 § Web).
//
// It lives outside routes/$org, so it inherits no auth guard — which is the
// point: the reader is a resident holding the link from their acknowledgement
// e-mail or the QR scan page, with no account. The reply token in the path is
// the entire authorization, and it unlocks exactly one thread.
export const Route = createFileRoute('/c/$orgCode/$token')({
    component: ResidentConversationRoute,
})

function ResidentConversationRoute() {
    const { orgCode, token } = Route.useParams()

    return <ResidentConversationPage orgCode={orgCode} token={token} />
}
